import EditorCoreState, { DropStateStore } from './state'

export function dropState(state: EditorCoreState): DropStateStore {
  return state.dropState
}

export function focusedComponentId(state: EditorCoreState): string {
  return state.focus.currentFocusId
}

export default {
  dropState,
  focusedComponentId
}
